import { createFileRoute } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { listAdminMembers } from "@/lib/dashboard.functions";

export const Route = createFileRoute("/admin/uyeler")({
  head: () => ({ meta: [{ title: "Üyeler · Yönetim" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: MembersPanel,
});

function MembersPanel() {
  const fn = useServerFn(listAdminMembers);
  const { data, isLoading, error } = useQuery({
    queryKey: ["admin-members"],
    queryFn: () => fn(),
  });

  const members = data?.members ?? [];

  return (
    <section>
      <div className="flex items-baseline justify-between mb-4">
        <h2 className="font-serif text-2xl">Üyeler</h2>
        <span className="text-[10px] uppercase tracking-[0.18em] text-ink/60">
          {isLoading ? "Yükleniyor…" : `${members.length} üye`}
        </span>
      </div>
      {error ? (
        <p className="text-sm text-clay">Hata: {(error as Error).message}</p>
      ) : isLoading ? (
        <p className="text-sm text-ink/60">Yükleniyor…</p>
      ) : members.length === 0 ? (
        <p className="text-sm text-ink/60">Henüz üye yok.</p>
      ) : (
        <div className="border border-border rounded overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-ink/5 text-[10px] uppercase tracking-[0.18em] text-ink/60">
              <tr>
                <th className="text-left px-3 py-2">Ad</th>
                <th className="text-left px-3 py-2">E-posta</th>
                <th className="text-left px-3 py-2">Kayıt</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m: any) => (
                <tr key={m.id} className="border-t border-border">
                  <td className="px-3 py-2">{m.full_name || "—"}</td>
                  <td className="px-3 py-2 text-ink/85">{m.email || "—"}</td>
                  <td className="px-3 py-2 text-ink/60">
                    {new Date(m.created_at).toLocaleDateString("tr-TR")}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

